import { GetState, SetState } from 'zustand';
import { SettingsStore } from 'store';

export function switchEnhancedDisputeSearch(set: SetState<SettingsStore>, get: GetState<SettingsStore>): void {
   const current: boolean = get().enhancedDisputeSearch;

   set({ enhancedDisputeSearch: !current });
}
